import * as URLConfig from "@frameworks/web/config/domain";
import { urlConstructor } from "@frameworks/web/config/domain";
var config = URLConfig.config;
var mandate = "mandate/";
export var MandateURL = {
    MfMandateList: urlConstructor(config.app_mf, mandate, "orderbook"),
    // MfMandateList: config.jmw + config.app_mf + "mandate/orderbook",
    // mfMandate: config.jmw + config.app_mf + "mandate",
    mandateCalendar: urlConstructor(config.app_mf, mandate, "calendar"),
    // mandateCalendar: `${config.jmw}${config.app_mf}mandate/calendar`,
    // emandateUrl: config.jmw + config.app_mf + "mandate/auth-status",
    // mandateLinkedSip: `${config.jmw}${config.app_mf}mandate/linked-sip`,
    // downloadMandate: config.jmw + config.app_mf + "mandate/download",
    mandateSwitch: urlConstructor(config.app_mf, mandate, "allowed-types"),
    // mandateSwitch: config.jmw + config.app_mf + "mandate/allowed-types", // not encrypting as no body
    mfBankDetails: urlConstructor(config.app_mf, "bank/", "summary"),
    mfBankDetailsNew: urlConstructor(config.app_mf, mandate, "bank"),
    // mfBankDetails: config.jmw + config.app_mf + "bank/summary",
    uploadMandateImage: config.jmw + config.jmw_mf + "upload/scanmandateimage",
    //mandateTimeline: urlConstructor(config.app_mf, mandate, "timeline"), // POST method for both
    //encrypted Version
    mfMandate: urlConstructor(config.app_mf, mandate, "v1/"),
    mfCreateMandate: urlConstructor(config.app_mf, mandate, "v1/create-mandate"),
    // mfCreateMandate: config.jmw + config.app_mf + "mandate/v1/create-mandate", // mfMandate POST version
    // mandateCalendar: config.jmw + config.app_mf + "mandate/v1/calendar",
    emandateUrl: config.jmw + config.app_mf + "mandate/v1/auth-status",
    downloadMandate: urlConstructor(config.app_mf, mandate, "v1/download"),
    // downloadMandate: config.jmw + config.app_mf + "mandate/v1/download",
    mandateLinkedSip: urlConstructor(config.app_mf, mandate, "v1/linked-sip"),
    mandateTimeline: urlConstructor(config.app_mf, mandate, "v1/timeline"),
};
